/**
 *
 */
export enum DaisyconEvent {
  Purchase = 'Paid Subscription',
  Signup = 'Signup',
}
